var FlvSoundFormat = {
  MP3: 2,
  G711A: 7,
  G711M: 8,
  AAC: 10,
  OPUS: 13
};
export { FlvSoundFormat };
